module.exports = __webpack_public_path__ + "assets/img/list-4.9cd2c42e.png";